<template>
 <div class='cumulativeRevenueDetailCont'>
     <van-nav-bar
      title="累计收益"
      left-arrow
      @click-left="
        backPreHandle()
      "
    />
    <div v-show="isShowTopFlag">
        <div class="cumulativeRevenueDetailTopBox">

            <div class="cumulativeRevenueDetailTop">
                <div class="promotionSearchBox" ref="searchBtnRef">
                    <input type="text" :class="{focusInput: isFocusIpt}" @focus="focusHanle()" v-model="searchKey" @:blur="changeInpt()"  placeholder="请输入商品名称/代理商名称"/>
                    <span class="searchIcon"></span>
                    <span class="escSearch" @click="escSearchIpt()" v-show="isFocusIpt"></span>
                    <span class="searchBtn"  v-show="isFocusIpt && !isShowEsc" @click="searchHandle()">搜索</span>
                    <span class="searchBtn"  v-show="isShowEsc" @click="escSearchIpt()">取消</span>
                    <!-- <div class="selectKuang">
                        <vant-action-sheet></vant-action-sheet>
                    </div> -->
                </div>

            </div>
        </div>
        <div class="threeMoneyCont">
            <div class="threeMoneyList">  
                <p class="threeMoneyText">{{detailTotalInfor && detailTotalInfor.orderIncome}}</p>
                <p class="threeMoneyTitle">订单收益</p>
            </div>
            <div class="threeMoneyList shuxianParent">  
                <p class="threeMoneyText">{{detailTotalInfor && detailTotalInfor.compensation}}</p>
                <p class="threeMoneyTitle" @click="showBuchaPopHandle()"><span class="benbuebuchaIcon">本月补差</span></p>
                <span class="shuxianStyle"></span>
            </div>

            <div class="threeMoneyList">  
                <p class="threeMoneyText shouyiText">{{detailTotalInfor && detailTotalInfor.income}}</p>
                <p class="threeMoneyTitle">本月收益</p>
            </div>

        </div>
    </div>

    <div class="cumulativeRevenueDetailTabCont" :class="{'vanTabsStyle': !isShowTopFlag, 'marginTop20': isShowTopFlag}">
        <van-tabs v-model="activeName" @click="clickTabHandle()">
            <van-tab title="直接推广" name="zhijietuiguang">
                <div class="tuiguangListCont">
                    <p class="tuiguangContTitle">
                        直接推广收益{{detailTotalInfor && detailTotalInfor.directIncome}}元  
                        <span>累计{{detailTotalInfor && detailTotalInfor.directOrderNum}}笔订单</span>
                    </p>
                    <commonTuiguangList v-if="listData.length" :tuiguangListData="listData" :currentActiveName="activeName"></commonTuiguangList>
                    <div class="noTuiguangList" v-else>暂无数据</div>   
                </div>

            </van-tab>
            <van-tab title="间接推广" name="jianjietuiguang"  >
                <div class="tuiguangListCont">
                    <p class="tuiguangContTitle">
                        间接推广收益 {{detailTotalInfor && detailTotalInfor.indirectIncome}}元  
                        <span>累计{{detailTotalInfor && detailTotalInfor.indirectOrderNum}}笔订单</span>
                    </p>
                    <commonTuiguangList v-if="listData.length" :tuiguangListData="listData"></commonTuiguangList>
                    <div class="noTuiguangList" v-else>暂无数据</div>   
                </div>
            </van-tab>
        </van-tabs>
    </div>

    <div class="detailPopCont" v-if="isShowBuchaPop">
        <div class="detailPopLayer"></div>
        <div class="detailPopContInforPadding">
            <div class="detailPopContInfor">
                <p class="detailPopContInforTitle">
                    若有佣金差额，本月最后一天计算佣金差额数据，并于次日更新
                </p>
                <div class="closeDetailPopBtn" @click="hidePopHandle()">我知道了</div>
            </div>
        </div>
    </div>

     <!-- <Footer></Footer> -->

 </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant';
import Footer from './footer';
import $ from "jquery";

import commonTuiguangList from './commonTuiguangList';

export default {
    name: "cumulativeRevenueDetail",
    data () {
        return {
            searchKey: null,
            isFocusIpt: false,
            isShowEsc: false,
            paging: {
                params: {
                    pageNum: 1,
                    pageSize: 10
                },

                total: 0,

                totalPages: 0,
            },

            activeName: 'zhijietuiguang',
            isShowTopFlag: true,
            isShowBuchaPop:false,

            detailTotalInfor: null,
            
            
            listData: [],
            loadMoreStatus: "more",
            total: 0,


        };
    },
    components: {
        commonTuiguangList,
    },

    computed: {

    },


    created(){
         localStorage.setItem("currentPromationNav",'mine')
         console.log('mouth', this.$route.query.mouth)
    },

    mounted(){
        this.getFindTotalIncome()
        this.getFindDirectIncome()

        $(window).scroll(() => {
            //判断是否滑动到页面底部
            if (
                Math.round($(window).scrollTop()) ===
                $(document).height() - $(window).height()
            ) {
                // TODO 滑动到底部时可请求下一页的数据并加载，加载可使用append方法
                this.reachBottom();
            }
        });
             

       
    },
    destroyed(){
        
    },

    methods: {

        backPreHandle() {
            this.$router.go(-1);
        },

        focusHanle() {
            this.isFocusIpt = true
        },

        escSearchIpt() {
            this.isFocusIpt = false;
            this.isShowEsc = false;
            this.searchKey = ''            
            this.postCurrentTabApi()

        },


        searchHandle() {
            this.postCurrentTabApi()
            this.isShowEsc = true
        },

        changeInpt() {
            if (!this.searchKey) {
                this.getData()
            }
        },

        getData() {
            
        },

        clickTabHandle(title) {
            this.postCurrentTabApi();
        },

        showBuchaPopHandle() {
            this.isShowBuchaPop = true
        },
        hidePopHandle() {
            this.isShowBuchaPop = false
        },

        //月累计收益
        getFindTotalIncome() {
            this.$api.agentManage.findTotalIncome(
                {
                    month: this.$route.query.mouth,             
                }
            )
            .then(res=>{
                if (res.data) {

                    this.detailTotalInfor = res.data
                } else {
                    Toast({
                        message: res.message,
                        duration: 4000,
                    });                

                }         

            })

        },



        //直接收益列表
        getFindDirectIncome(type) {
            this.$api.agentManage.findDirectIncome(
                {
                    keyWord: this.searchKey,
                    month: this.$route.query.mouth,
                    pageNum: this.paging.params.pageNum,
                    pageSize:  this.paging.params.pageSize,
                }

            )
            .then(res=>{
                    if (type === "reachBottom") {
                        this.listData = this.listData.concat(res.data.list);
                        console.log('listData====',  this.listData)
                    } else {
                        this.listData = res.data.list || [];
                    }
                    this.total = res.data.total;
                    if (this.total <= this.paging.params.pageNum * this.paging.params.pageSize) {
                        this.loadMoreStatus =
                            type === "reachBottom" ? "noMore" : "none";
                    } else {
                        this.loadMoreStatus = "more";
                    }
            })

        },


        //间接收益列表
        getFindIndirectIncome(type) {
            this.$api.agentManage.findIndirectIncome(
                {
                    keyWord: this.searchKey,
                    month: this.$route.query.mouth,
                    pageNum: this.paging.params.pageNum,
                    pageSize:  this.paging.params.pageSize,
                }

            )
            .then(res=>{
                    if (type === "reachBottom") {
                        this.listData = this.listData.concat(res.data.list);
                    } else {
                        this.listData = res.data.list || [];
                    }
                    this.total = res.data.total;
                    if (this.total <= this.paging.params.pageNum * this.paging.params.pageSize) {
                        this.loadMoreStatus =
                            type === "reachBottom" ? "noMore" : "none";
                    } else {
                        this.loadMoreStatus = "more";
                    }
            })

        },





        
        scrollFn() {
            $(document).scroll(()=> {
                console.log(' document.documentElement.scrollTop==',  document.documentElement.scrollTop);
                if (document.documentElement.scrollTop > 10) {
                    this.isShowTopFlag = false
                } 
    
                if (document.documentElement.scrollTop == 0) {
                    this.isShowTopFlag = true
                }     
            
            });

        },


        postCurrentTabApi() {
            if (this.activeName == 'zhijietuiguang') {
                this.paging.params.pageNum = 1;
                this.getFindDirectIncome()

            } else {
                this.paging.params.pageNum = 1;
                this.getFindIndirectIncome()
            }

        },


        reachBottom() {
            if (this.total > this.paging.params.pageNum * this.paging.params.pageSize) {
                this.paging.params.pageNum = this.paging.params.pageNum + 1;
                this.loadMoreStatus = "loading";
                if (this.activeName == 'zhijietuiguang') {
                    this.getFindDirectIncome('reachBottom')

                } else {
                    this.getFindIndirectIncome('reachBottom')
                }

                
            } else {
                this.loadMoreStatus = "noMore";
            }
        },





       
    },



}

</script>


<style  scoped>
 @import "../asset/css/agentManage.css";
</style>

